<template>
  <div class="columns admin-submenu">
    <div class="column has-text-centered">
      <router-link
        class="admin-submenu-button"
        :to="{ name: 'filer-administration' }"
        :disabled="$route.name === 'filer-administration'"
      >
        <div class="icon is-large">
          <i class="fad fa-users fa-2x" />
        </div>
        <div class="is-size-5">
          View Users
        </div>
      </router-link>
    </div>
    <div class="column has-text-centered">
      <router-link
        class="admin-submenu-button"
        :to="{ name: 'import-filers' }"
        :disabled="$route.name === 'import-filers'"
      >
        <div class="icon is-large">
          <i class="fad fa-upload fa-2x" />
        </div>
        <div class="is-size-5">
          Import Filers
        </div>
      </router-link>
    </div>
    <div class="column has-text-centered">
      <a
        class="admin-submenu-button"
        href=""
        @click.prevent="showNewuserModal"
      >
        <div class="icon is-large">
          <i class="fad fa-user-plus fa-2x" />
        </div>
        <div class="is-size-5">
          Add User
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import RegisterUser from '@/modals/RegisterUser';

export default {
  name: 'AdminSubMenu',
  methods: {
    showNewuserModal() {
      this.$modal.show(
        RegisterUser,
        null,
        {
          classes: [ 'is-large' ],
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .admin-submenu {
    .column {
      border-left: 1px solid #cfcfcf;
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: 0;
      }
    }
  }
  .admin-submenu-button {
    &[disabled],
    &[disabled="disabled"],
    .disabled {
      color: #6b6b6b;
      cursor: default;
    }
  }
</style>
